import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../../../environments/ev/environment.ev.deployment';

@Component({
  selector: 'app-captcha-page',
  templateUrl: './captcha-page.component.html',
  styleUrls: ['./captcha-page.component.css']
})
export class CaptchaPageComponent implements OnDestroy {
  form!: FormGroup;
  captchaValue = '';
  captchaError = '';

  countdown = 60; // 1 minute
  private timer: any;

  constructor(private fb: FormBuilder, private router: Router,
    private keycloakservice:KeycloakService
  ) {}

  ngOnInit() {
    this.generateCaptcha();
    this.form = this.fb.group({
      captchaInput: ['', Validators.required]
    });

    // this.startCountdown();
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  generateCaptcha() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const length = 6;
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    this.captchaValue = result;
    this.captchaError = '';
  }

  startCountdown() {
    this.countdown = 20;
    this.timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.timer);

        // this.router.navigate(['/login']); // redirect to login
        //  window.location.href = 'https://portal.evnextgenappsqa.tatamotors.com/';
        this.keycloakservice.logout(); 
      }
      // else{
     
      // }
    }, 1000);
  }

  onSubmit() {
    debugger
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const userInput = this.form.value.captchaInput;
    if (userInput !== this.captchaValue) {
      this.captchaError = 'Captcha does not match. Please try again.';
      this.generateCaptcha();
      this.form.patchValue({ captchaInput: '' });
      return;
    }else{
      window.location.href = environment.baseUrl.replace("nextgenev-apps/", "home")  //'http://localhost:4500/home'//environment.baseUrl //'https://portal.evnextgenappsqa.tatamotors.com/';
    }

    this.captchaError = '';
    clearInterval(this.timer); // stop timer on success
    // this.router.navigate(['/redirect-landing']);
  }
}
